//  检测元素是否在屏幕内
const isElementNotInViewport = function(el) {
  let rect = el.getBoundingClientRect();
  return (
    rect.top >= (window.innerHeight || document.documentElement.clientHeight)
    || rect.bottom <= 0
  );
};

//  防抖函数
function debounce(fn, wait) {
  var timeout = null;
  return function() {
    if (timeout !== null)   { clearTimeout(timeout) }
    timeout = setTimeout(fn, wait);
  };
}

//  节流
function throttle(func, delay) {
  var timer = null;
  var startTime = Date.now();
  return function() {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      timer = setTimeout(() => { func.apply(context, args) }, remaining);
    }
  };
}

// 计算区间随机数
export const getRndInteger = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// 根据组件名称向上找到最近的指定组件
export const findComponentUpwardByName = (context, componentName) => {
  let parent = context.$parent;
  let name = parent.$options.name;
  while (parent && (!name || [componentName].indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) {
      name = parent.$options.name;
    }
  }
  return parent;
};

// 根据组事件称向上找到最近的指定组件
export const findComponentUpwardByEvent = (context, eventName) => {
  let parent = context.$parent;
  let event = parent[eventName];
  while (parent && !event) {
    parent = parent.$parent;
    if (parent) {
      event = parent[eventName];
    }
  }
  return parent;
};

// 根据组件名称向下找到最近的指定组件
// @aigc:start 2024/06/12-11:10
export function findComponentDownByName(parent, name) {
  if (!parent) { return null }

  // 检查当前组件名称
  if (parent.$options.name === name) {
    return parent;
  }

  // 递归查找子组件
  for (let i = 0; i < parent.$children.length; i++) {
    const child = findComponentDownByName(parent.$children[i], name);
    if (child) {
      return child;
    }
  }

  return null;
}
// @aigc:end 2024/06/12-11:10

// 多次decode,直到'://'出现
export const loopDecode = (url) => {
  let resultUrl = url;
  let cycles = 0;
  // 判断跳转的URL 含有'://'或者循环10次，都要跳出循环
  while (resultUrl.indexOf('://') == -1 && cycles < 10) {
    cycles++;
    resultUrl = decodeURIComponent(resultUrl);
  }
  if (resultUrl.indexOf('://') != -1) {
    return resultUrl;
  } else {
    return false;
  }
};


// @aigc:start 2024/01/12-17:38
/**
 * 将嵌套的数组展平为一维数组
 *
 * @param arr 待展平的数组
 * @returns 展平后的数组
 */
export function flattenArray(arr) {
  let result = []; // 创建一个空数组来存储结果
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      // 如果元素是数组，则递归调用 flattenArray
      result = result.concat(flattenArray(arr[i]));
    } else {
      // 如果元素不是数组，则直接添加到结果数组中
      result.push(arr[i]);
    }
  }
  return result;
}

// @aigc:end 2024/01/12-17:38

export { isElementNotInViewport, debounce, throttle };